
























































import {Component, Prop, Vue} from 'vue-property-decorator';
import Cell from "@/app/minesweeper/Cell";
import CellSquare from "@/components/CellSquare.vue";
import Camera from "@/components/Camera.vue";
import Player from "@/app/minesweeper/Player";
import {OpenedNeighbourCells, GameState} from "@/app/minesweeper/enum";
import PlayersDashboard from "@/components/PlayersDashboard.vue";
import GameBuilder from "@/app/minesweeper/GameBuilder";
import PlayerBuilder from "@/app/minesweeper/PlayerBuilder";
import ComputerPlayerBuilder from "@/app/minesweeper/ComputerPlayerBuilder";
import ComputerPlayer from "@/app/minesweeper/ComputerPlayer";
import Minesweeper from "@/app/minesweeper/Minesweeper";

@Component({
    components: {PlayersDashboard, Camera, CellSquare}
})
export default class GameField extends Vue {
    @Prop() width!: number;
    @Prop() height!: number;
    @Prop() mines!: number;
    @Prop() speed!: number;
    @Prop() lives!: number;

    cells: Cell[][] = [];
    private minesweeper!: Minesweeper;
    private currentPlayer!: Player;
    private sceneWidth = 0;
    private sceneHeight = 0;

    private GameState = GameState;

    created() {
        if (this.width) {
            this.sceneWidth = this.width * 30;
        }
        if (this.height) {
            this.sceneHeight = this.height * 30;
        }

        this.startGame();
    }

    startGame(): void {
        const humanPlayerBuilder = PlayerBuilder
            .newInstance()
            .setName('You')
            .setStartingCellX(0)
            .setStartingCellY(0)
            .setLives(this.lives);

        const computerPlayerBuilder = ComputerPlayerBuilder
            .newInstance()
            .setName('Computer')
            .setStartingCellX(this.width - 1)
            .setStartingCellY(this.height - 1)
            .setLives(this.lives)
            .setSpeed(this.speed);

        this.minesweeper = GameBuilder
            .newInstance()
            .setWidth(this.width)
            .setHeight(this.height)
            .setMinesRandomPlacement(true)
            .setMines(this.mines)
            .setLives(this.lives)
            .addPlayerBuilder(humanPlayerBuilder)
            .addPlayerBuilder(computerPlayerBuilder)
            .create();

        this.minesweeper.players.map(player => {
            if (!(player instanceof ComputerPlayer)) {
                this.currentPlayer = player;
            }
        });

        // init minesweeper
        this.minesweeper.initialize();
        this.cells = this.minesweeper.cells;

        // start minesweeper
        this.minesweeper.start();

        this.minesweeper.players.map(player => {
            if (player instanceof ComputerPlayer) {
                player.playGame();
            }
        });
    }

    restartGame(): void {
        // drop references so Vue can update dashboard component
        this.minesweeper.players = [];
        this.startGame();
    }

    onFlagCell(cell: Cell): void {
        this.minesweeper.setCellFlagged(cell, !cell.isFlagged(), this.currentPlayer);
    }

    onOpenCell(cell: Cell): void {
        this.minesweeper.openCell(cell, this.currentPlayer, OpenedNeighbourCells.Unknown);
    }
}
